const profile = {
    name: 'Nombre',
    avatar: 'Avatar',
    givenName: 'Nombre de pila',
    familyName: 'Apellido',
    middleName: 'Segundo nombre',
    fullname: 'Nombre completo',
    nickname: 'Apodo',
    preferredUsername: 'Nombre de usuario preferido',
    profile: 'Perfil',
    website: 'Sitio web',
    gender: 'Género',
    birthdate: 'Fecha de nacimiento',
    zoneinfo: 'Zona horaria',
    locale: 'Configuración regional',
    address: {
        formatted: 'Dirección',
        streetAddress: 'Dirección',
        locality: 'Ciudad',
        region: 'Estado/Provincia',
        postalCode: 'Código postal',
        country: 'País',
    },
    gender_options: {
        female: 'Femenino',
        male: 'Masculino',
        prefer_not_to_say: 'Prefiero no decir',
    },
    checkbox_value: {
        checked: 'Sí',
        unchecked: 'No',
    },
    avatar_upload: {
        upload: 'Subir',
        remove: 'Eliminar',
        uploading: 'Subiendo...',
        hint: 'Tamaño recomendado 1:1, hasta {{limit}}.',
        error_file_type: 'El tipo de archivo debe ser {{extensions}}.',
        error_file_size: 'El tamaño del archivo no debe superar {{limit}}.',
        error_storage_not_configured: 'No se pudo subir la foto. Inténtalo de nuevo más tarde.',
        error_upload: 'No se pudo subir la foto. Inténtalo de nuevo.',
        error_save: 'No se pudo guardar tu foto. Inténtalo de nuevo.',
        crop_title: 'Recortar foto',
        zoom: 'Zoom',
        error_crop: 'No se pudo recortar la imagen. Inténtalo de nuevo.',
    },
};
export default Object.freeze(profile);
